import store from "@/store";
import paths from "./paths";

function isLogged() {
    return store.state.userSession ? true : false;
}

export function authCheck(to, from, next) {
    if (isLogged()) {
        next({ path: to });
    } else {
        next({ path: paths.login });
    }
}